module.exports = __webpack_public_path__ + "media/images/steps/svg/193-meeting-4-25a81ed4d1cb8a26635f106444f7ea4d.png";